import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "body2-text text-black",
    title: "라이더이름 / 라이더코드, 사번"
};
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
const _hoisted_12 = { class: "body2-text text-black" };
const _hoisted_13 = { class: "body2-text text-black" };
const _hoisted_14 = { class: "body2-text text-black" };
const _hoisted_15 = { class: "body2-text text-black" };
const _hoisted_16 = { class: "body2-text text-black" };
const _hoisted_17 = { class: "body2-text text-black" };
const _hoisted_18 = { class: "body2-text text-black" };
import { employeeTypeCode, workerUseYnTypeCode, } from '@/constants';
import { salaryTypeData, typeData, } from '@/constants/workerManagementList';
import { currency, formatBankAccount, injectSeparatorDateString, injectSeparatorTimeString, validateTextWithHypen, changeStartEndStringTimeZone, } from '@/utils';
import InputRow from '@/components/Form/InputRow.vue';
import { computed, toRefs } from 'vue';
import { timeZoneCode } from '@/constants/global';
import { formatPhoneNumber } from '@/utils/regularExpression';
import vuexStore from '@/vuex-store';
const lc = 'views.worker_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkInfo',
    props: {
        detail: { default: () => ({}) }
    },
    setup(__props) {
        // 라이더 상세 > 근무 정보
        const props = __props;
        const { detail, } = toRefs(props);
        const workerName = computed(() => {
            const code = validateTextWithHypen(detail.value.code);
            const hubEmployeeNumber = validateTextWithHypen(detail.value.hubEmployeeNumber);
            const name = validateTextWithHypen(detail.value.name);
            const fullWorkerName = `${name} / ${code}, ${hubEmployeeNumber}`;
            return fullWorkerName;
        });
        // 라이더 상태
        const workerUseYn = computed(() => workerUseYnTypeCode[detail.value.useYn]?.text);
        // 근무 시간
        const workTime = computed(() => {
            if (detail.value.workTime) {
                const krTimeString = changeStartEndStringTimeZone(detail.value.workTime, timeZoneCode.KR);
                return injectSeparatorTimeString(krTimeString);
            }
            return '';
        });
        // 단말기 번호
        const phone = computed(() => validateTextWithHypen(formatPhoneNumber(detail.value.phone)));
        // 대체 연락처
        const telNumber = computed(() => validateTextWithHypen(formatPhoneNumber(detail.value.telNumber)));
        // 고용 형태
        const employeeTypeText = computed(() => employeeTypeCode[detail.value.employeeType]?.text);
        // 보수 지급방식
        const salaryType = computed(() => salaryTypeData[detail.value.salaryType]?.text);
        // 주소
        const homeAddress = computed(() => validateTextWithHypen(detail.value.homeAddress));
        // 라이더 유형
        const workerType = computed(() => typeData[detail.value.type]?.text);
        // 입사일
        const workerRegDate = computed(() => injectSeparatorDateString(detail.value.workerRegDate));
        // 퇴사일
        const workerLeaveDate = computed(() => validateTextWithHypen(injectSeparatorDateString(detail.value.workerLeaveDate)));
        // 관리자 메모
        const memo = computed(() => validateTextWithHypen(detail.value.memo));
        // 예치금
        const depositBaromoney = computed(() => currency(detail.value.depositBaromoney));
        // 바로머니 잔액
        const baromoneyWithCurrency = computed(() => currency(detail.value.baromoney));
        // 충전용 가상계좌 정보 (은행명 계좌번호)
        const virtualAccount = computed(() => {
            const bankName = vuexStore.getters['systemCode/getBankName'](detail.value.virtualBankCode);
            const bankAccount = formatBankAccount(detail.value.virtualBankAccount);
            const fullInfo = (bankName && bankAccount) ? `${bankName} ${bankAccount}` : '-';
            return fullInfo;
        });
        // 출금계좌 정보 (이름 / 은행명 계좌번호 )
        const withdrawalAccount = computed(() => {
            const bankName = vuexStore.getters['systemCode/getBankName'](detail.value.withdrawalBankCode);
            const bankAccount = formatBankAccount(detail.value.withdrawalBankAccount);
            const ownerName = detail.value.withdrawalBankOwner;
            const fullInfo = (ownerName && bankName && bankAccount) ? `${ownerName} / ${bankName} ${bankAccount}` : '-';
            return fullInfo;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" 라이더명 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_name`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(workerName.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 소속 허브 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}belog_hub`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(detail).hubName) + " / " + _toDisplayString(_unref(detail).hubCode), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 고용형태 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_employee_type`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(employeeTypeText.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 보수 지급방식 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}salary_type`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(salaryType.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 단말기번호 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}phone`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(phone.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 대체연락처 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}tel_number`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(telNumber.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 라이더 상태 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_use_yn_type`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(workerUseYn.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 근무 시간 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}work_time`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(workTime.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 주소 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}home_address`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(homeAddress.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 라이더 유형 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_type`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(workerType.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 입사일 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_reg_date`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(workerRegDate.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 퇴사일 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_leave_date`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(workerLeaveDate.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 관리자 메모 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}memo`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(memo.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 예치금 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}deposit_baromoney`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(depositBaromoney.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 바로머니 잔액 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}baromoney_balance`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(baromoneyWithCurrency.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 충전용 가상계좌 정보  "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}virtual_bank_account_info`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(virtualAccount.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 출금계좌 정보 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}withdraw_bank_info`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(withdrawalAccount.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 결격 상태 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}conviction_status`),
                    "wide-title": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(detail).convictionStatusForUser), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"])
            ]));
        };
    }
});
